import { Box } from "sprout-ui-primitives";
import styled from "styled-components";
const LandingSection = styled(Box).attrs({
    as: "section"
})``;
LandingSection.defaultProps = {
    px: 7
};
export default LandingSection;
